import { Button, Form, Modal, Spinner } from 'react-bootstrap';
import API from 'utils/atolyeAPI';
import alert from 'js/sweetAlert';
import { useEffect, useState } from 'react';

const AtolyeAPI = new API();

const EditOrderNoteModal = ({ show, onDismiss, note, refresh }) => {
  // State

  const [isLoading, setIsLoading] = useState(false);
  const [name, setName] = useState('');
  const [description, setDescription] = useState('');

  // Effects

  useEffect(() => {
    if (note) {
      setName(note.name);
      setDescription(note.description);
    }
  }, [note]);

  // Functions

  const editOrderNote = async () => {
    if (!name) {
      return alert('error', 'Taslak Adı boş bırakılamaz');
    }

    const body = {
      name,
      description,
    };

    setIsLoading(true);

    try {
      const { status } = await AtolyeAPI.put(`/order_notes/${note.id}`, body);

      if (status && status === 'SUCCESS') {
        return alert('success', 'Sipariş Notu Taslağı başarıyla güncellendi');
      }
      return alert('error', 'Sipariş Notu Taslağı güncellenirken bir hata oluştu');
    } catch (error) {
      alert('error', 'Sipariş Notu Taslağı güncellenirken bir hata oluştu');
      console.log(error);
    } finally {
      setIsLoading(false);
      setName('');
      setDescription('');
      onDismiss();
      refresh(true);
    }
  };

  return (
    <Modal show={show} onHide={onDismiss}>
      <Modal.Header className="bg-primary" closeButton>
        <Modal.Title>Taslak No: {note.id} - Düzenle</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form.Group className="mb-3" controlId="formBasicEmail">
          <Form.Label>Taslak Adı</Form.Label>
          <Form.Control type="text" value={name} onChange={(e) => setName(e.target.value)} />
          <Form.Text className="text-muted">Taslak Adı girin. Bu alan zorunludur</Form.Text>
        </Form.Group>
        <Form.Group className="mb-3" controlId="formBasicEmail">
          <Form.Label>Taslak Metni</Form.Label>
          <Form.Control
            as="textarea"
            rows={8}
            value={description}
            onChange={(e) => setDescription(e.target.value)}
          />
          <Form.Text className="text-muted">Taslak içeriğini buraya yazın</Form.Text>
        </Form.Group>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="light" onClick={onDismiss}>
          Vazgeç
        </Button>
        <Button variant="success" onClick={() => editOrderNote()}>
          {isLoading ? (
            <Spinner animation="border" role="status">
              <span className="visually-hidden">Loading...</span>
            </Spinner>
          ) : (
            'Güncelle'
          )}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default EditOrderNoteModal;
